import { render, staticRenderFns } from "./DataModel.vue?vue&type=template&id=d65df638&scoped=true&"
import script from "./DataModel.vue?vue&type=script&lang=js&"
export * from "./DataModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65df638",
  null
  
)

export default component.exports